// ============================================
// rafThrottle
// scroll / resize など高頻度で発火するイベントを
// requestAnimationFrame で「次のフレームに1回だけ」間引く共通ユーティリティ。
//
// 使い方:
//   window.addEventListener('scroll', rafThrottle(onScroll), { passive: true });
// ============================================
export function rafThrottle(callback) {
  let ticking = false;
  return (...args) => {
    if (ticking) return; // すでに次フレームで処理が予約されていればスキップ
    ticking = true;
    requestAnimationFrame(() => {
      callback(...args);
      ticking = false; // 処理完了後にフラグをリセット
    });
  };
}
